import { createFileRoute } from '@tanstack/react-router'

import { loadIssuesRedirect } from '@/screens/ipo/IssuesRedirect.loader'

/**
 * `/issues` — Public Issues' old URL, kept for bookmarks. The loader always
 * redirects to `/market/issues`, so `component` never renders on a real
 * visit; see `ByStockRedirect.tsx`. No `validateSearch`: nothing links here
 * any more, and the loader parses the raw search with the screen's own
 * schema to carry it across.
 */
export const Route = createFileRoute('/_app/issues')({
  loader: loadIssuesRedirect,
  component: () => null,
})
